import PropTypes from "prop-types";
import { MdCheckCircleOutline, MdOutlineCancel } from "react-icons/md";
import styles from "./styles.module.css";

const StatusBadge = ({ status, label }) => {
  let statusLabel = status ? "Active" : "Inactive";
  if (label) {
    statusLabel = label;
  }

  return (
    <div
      className={`${styles["status-badge"]} ${
        status ? styles["status-active"] : styles["status-inactive"]
      }`}
    >
      {status ? (
        <MdCheckCircleOutline size={14} aria-hidden="true" />
      ) : (
        <MdOutlineCancel size={14} aria-hidden="true" />
      )}
      {statusLabel}
    </div>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.bool,
  label: PropTypes.string,
};

export default StatusBadge;
